import React, {useState, useEffect} from "react"
import {
    Box,
    Button,
    Container,
} from "@mui/material";
import {CmCollection} from "../../../packages/graphql-layer/src";
import {useTranslation} from "react-i18next";
import "../../utility/i18n"


interface Props {
    cmCollection?: CmCollection,
    children: any,
    maxItemDisplayed?: number,
    showMoreCount?: number,
    itemsList?: any,
    showMoreLabel?: string
    loadableItemClass?: string
}

function CCOLoadableContainer(props: Props) {
    const defaultMaxItemsShown = 3;
    const defaultShowMoreCount = 1;
    const items = props.itemsList? props.itemsList: props.cmCollection?.items;
    const loadableItemClass = props.loadableItemClass ? '.' + props.loadableItemClass : '';
    const maxItemsShown = props.maxItemDisplayed ?? defaultMaxItemsShown;
    const [itemsShown, setItemsShown] = useState<number>(props.maxItemDisplayed ?? defaultMaxItemsShown);

    // collection preview in studio does not work without the effect
    useEffect(() => {
        setItemsShown(props.maxItemDisplayed ?? defaultMaxItemsShown); // aktualisiert sich, wenn die Prop sich ändert
    }, [props.maxItemDisplayed]);

    const showMore = () => {
        if (items && itemsShown < items.length) {
            setItemsShown(prevItemsShown => Math.min(prevItemsShown + (props.showMoreCount ?? defaultShowMoreCount), items!.length));
        }
    };

    const showLess = () => {
        if (items && itemsShown > maxItemsShown) {
            setItemsShown(prevItemsShown => Math.max(prevItemsShown - (props.showMoreCount ?? defaultShowMoreCount), maxItemsShown));
        }
    };

    const {t} = useTranslation();

    return (
        <Container sx={{paddingX: '0!important',
            [`div${loadableItemClass}:nth-of-type(n+${itemsShown + 1})`] : {
                display: 'none!important'
            }
        }}>
            {props.children}

            <Box textAlign='center'>
                {(items && items.length > maxItemsShown) ?
                <Button variant={itemsShown >= items.length? "outlined": "contained"}
                        size={'large'} sx={{marginX: 1, marginTop: 12}}
                        onClick={showMore} >{props.showMoreLabel ?? t("coo_show_more")}
                </Button> : null}
                {(items && itemsShown > maxItemsShown) ?
                <Button variant={"contained"} size={'large'} sx={{marginX: 1, marginTop: 12}}
                        onClick={showLess} >{t("coo_show_less")}</Button> : null}
            </Box>
        </Container>
    )
}

export default CCOLoadableContainer